import { render } from "./AndroidBlack.vue?vue&type=template&id=c89a5644"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/AndroidBlack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c89a5644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c89a5644', __exports__)) {
    api.reload('c89a5644', __exports__)
  }
  
  module.hot.accept("./AndroidBlack.vue?vue&type=template&id=c89a5644", () => {
    api.rerender('c89a5644', render)
  })

}


export default __exports__